"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _excluded = ["children", "className", "disabled", "focused", "onBlur", "onChange", "onFocus", "readonly", "selected", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'vds-chip';
var CSS_STATE = 'vds-state';
var Chip = (0, _react.forwardRef)(function (_ref, ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      focused = _ref.focused,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      readonly = _ref.readonly,
      selected = _ref.selected,
      type = _ref.type,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(focused),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = (0, _react.useState)(selected),
      _useState4 = _slicedToArray(_useState3, 2),
      select = _useState4[0],
      setSelect = _useState4[1];

  (0, _react.useEffect)(function () {
    setFocus(focused);
  }, [focused]);
  (0, _react.useEffect)(function () {
    setSelect(selected);
  }, [selected]);

  var handleFocus = function handleFocus(event) {
    setFocus(true);

    if (typeof onFocus === 'function') {
      onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocus(false);

    if (typeof onBlur === 'function') {
      onBlur(event);
    }
  };

  var handleChange = function handleChange(event) {
    setSelect(event.target.checked);

    if (typeof onChange === 'function') {
      onChange(event);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames2.default)((_classnames = {}, _defineProperty(_classnames, "".concat(CSS_PREFIX), type === 'default'), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--filter"), type === 'filter'), _defineProperty(_classnames, "".concat(CSS_STATE, "--disabled"), Boolean(disabled)), _defineProperty(_classnames, "".concat(CSS_STATE, "--readonly"), Boolean(readonly)), _defineProperty(_classnames, "".concat(CSS_STATE, "--selected"), Boolean(select)), _defineProperty(_classnames, "".concat(CSS_STATE, "--focus"), Boolean(focus)), _classnames), className),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    tabIndex: disabled ? -1 : undefined,
    ref: ref
  }, remainingProps), children);
});
Chip.propTypes = {
  /**
  * @ignore
  */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
  * disabled
  */
  disabled: _propTypes.bool,

  /**
  * focused
  */
  focused: _propTypes.bool,

  /**
   * Callback fired when the input element loses focus.
   */
  onBlur: _propTypes.func,

  /**
   * Callback fired when the input element loses focus.
   */
  onChange: _propTypes.func,

  /**
   * Callback fired when the input element is focused on.
   */
  onFocus: _propTypes.func,

  /**
  * Readonly
  */
  readonly: _propTypes.bool,

  /**
  * Selected
  */
  selected: _propTypes.bool,

  /**
   * Type
   */
  type: (0, _propTypes.oneOf)(['default', 'filter'])
};
Chip.defaultProps = {
  type: 'default'
};
Chip.displayName = 'Chip';
var _default = Chip;
exports.default = _default;